import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useRef } from "react";
import { useLocalStorage } from "react-use";
import { API_KEY, APP_SLUG } from "../../../constants/index.ts";

/**
 * This hook performs the following login tasks, given an app:
 *
 * 1. Checks for an existing app in local storage.
 * 2. If there's an existing app and it's different from the current app, then
 *    clear the API token and invalidate all queries.
 * 3. Sets the app inside local storage for use in the queries in `api/`
 */
export function useSetApp(app: string | null) {
  const [initialApp, setInitialApp] = useLocalStorage<string>(
    APP_SLUG,
    undefined,
    { raw: true },
  );

  const queryClient = useQueryClient();

  const originalAppRef = useRef(initialApp);

  useEffect(() => {
    if (originalAppRef.current && app && originalAppRef.current !== app) {
      sessionStorage.removeItem(API_KEY);
      queryClient
        .invalidateQueries({ queryKey: [] })
        .catch((error) => console.error("Failed to invalidate queries", error));
    }

    if (app) {
      setInitialApp(app);
    }
  }, [app, queryClient, setInitialApp]);
}
